import React, {useContext} from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, makeStyles, Typography } from '@material-ui/core'
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import { useRouteMatch } from 'react-router';
import { RenderExistingUnits } from './RenderExistingUnits';
import { useTranslation } from "react-i18next";
import {ChosenUnit, UnitsContext} from "../../../components/contexts/UnitsContext";

const facilityIcons: { [key: string]: string } = {
    'Entrance': '/static/img/icons/facilityIcons/entranceIcon.svg',
    'Reception and Lobby': '/static/img/icons/facilityIcons/receptionIcon.svg',
    'Elevators': '/static/img/icons/facilityIcons/elevators.svg',
    'Hospitality room type': '/static/img/icons/facilityIcons/hospitalityRoom.svg'
}

const useStyles = makeStyles((theme) => ({
    alignItemsCenter: {
        display: "flex",
        alignItems: "center"
    },
    flexColumn: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
    },
    accordionDetails: {
        display: "flex",
        width: "100%",
        background: '#ffffff5e',
        borderRadius: '7px',
        cursor: 'pointer'
    },
    selected: {
        display: "flex",
        width: "100%",
        borderRadius: '7px',
        background: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
        cursor: 'pointer'
    },
    addUnit: {
        color: "black"
    }
}))

type RenderFacilitiesItemType = {
    index: number,
    item: string,
    unitKey: string,
    handleNewUnitClick: (unitType: string, name: string) => void,
    expanded: string | boolean,
    handleChangeAccordion: (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => void
}
export const RenderFacilitiesItem = ({ index, item, unitKey, handleNewUnitClick, expanded, handleChangeAccordion }: RenderFacilitiesItemType) => {
    const { url } = useRouteMatch();
    const styles = useStyles();
    const { t } = useTranslation();
    const { existingUnitState, chosenUnitState, currentUnitState } = useContext(UnitsContext)
    const [chosenUnit] = chosenUnitState

    const isAddNewUnit = (chosenUnit: ChosenUnit) => {
        const {facilitiesIndex, unityIndex, unityId} = chosenUnit
        return facilitiesIndex === null && unityIndex === null && unityId === null
    }

    return (
        <Accordion
            expanded={expanded === `accordion-${index}`}
            onChange={handleChangeAccordion(`accordion-${index}`)}
            defaultExpanded={index === 0}
        >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              onClick={() => handleNewUnitClick(unitKey, item)}
            >
                <Box className={styles.alignItemsCenter}>
                    <img src={facilityIcons[item] ? facilityIcons[item] : '/static/img/icons/facilityIcons/newUnitIcon.svg'} alt="Unit" />
                    <Typography className="AccordionText">{item}</Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <Box className={styles.flexColumn}>
                    <RenderExistingUnits type={unitKey} facilityIndex={index} />
                    {url.includes('edit-facilities') || url.includes('create-new-property')?
                        <Box
                            py={2}
                            pl={13}
                            className={isAddNewUnit(chosenUnit) ? styles.selected : styles.accordionDetails}
                            onClick={() => handleNewUnitClick(unitKey, item)}
                        >
                            <img src="/static/img/icons/facilityIcons/addUnitIcon.svg" alt="" />
                            <Box ml={2}>
                                <Typography className={styles.addUnit}>
                                    {t("questionUnits_addNewUnit")}
                                </Typography>
                            </Box>
                        </Box> : null
                    }
                </Box>
            </AccordionDetails>
        </Accordion>
    )
}